import { alpha, styled } from '@mui/material';
import { FONT_DISPLAY } from 'themes/tokens';

export const LoginBackground = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  backgroundImage: `radial-gradient(circle at 15% 0%, ${alpha(theme.palette.primary.main, 0.28)} 0%, transparent 45%),
    radial-gradient(circle at 85% 100%, ${alpha(theme.palette.accent.main, 0.16)} 0%, transparent 45%)`,
}));

export const LoginCard = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 420,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(5, 4),
  borderRadius: 20,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: `0 40px 80px -40px ${alpha('#000000', 0.65)}`,
}));

export const LoginWordmark = styled('div')(({ theme }) => ({
  fontFamily: FONT_DISPLAY,
  fontWeight: 700,
  fontSize: 40,
  lineHeight: 1,
  letterSpacing: '-0.03em',
  color: theme.palette.text.primary,
  userSelect: 'none',
  '& .gtx-dot': {
    color: theme.palette.accent.main,
  },
}));

export const LoginForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));
